
import { cn } from '@/lib/utils';

/** Color-agnostic loading spinner (inherits currentColor). The single sanctioned
 *  spinner — replaces the hand-rolled `animate-spin border-...` spans in forms. */
export function Spinner({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent motion-reduce:animate-none',
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
}
